// extracted by mini-css-extract-plugin
export default {"centeredContent":"company-create_centeredContent__4d9gd","inputLabel":"company-create_inputLabel__UXHaC","cniPreview":"company-create_cniPreview__I1Y33"};